import useAuthApi from "../helpers/authHook";

export const refundService = {
  getAll,
  approve,
  reject,
  transform
};

async function getAll() {
  try {
    const privateAuth = useAuthApi();
    const response = await privateAuth.get("refund");
    return Array.isArray(response.data.data)
      ? response.data.data
      : [];
  } catch (e) {
    console.error("Fetch refunds failed", e);
    return [];
  }
}

async function approve(refundId, data) {
  const privateAuth = useAuthApi();
  return privateAuth.patch(`refund/${refundId}/approve`, data);
}

async function reject(refundId) {
  const privateAuth = useAuthApi();
  return privateAuth.put(`refund/${refundId}/reject`);
}

function transform(rows = []) {
  return rows.map((r, i) => ({
    id: i + 1,                     // table serial no
    refundId: r.refundId,          // ✅ REQUIRED for approve/reject
    _id: r.refundId,               // optional (if used elsewhere)

    firstName: r.firstName,
    lastName: r.lastName,
    fullName: `${r.firstName || ""} ${r.lastName || ""}`.trim(),

    email: r.email,
    phone: r.phone,

    pnr_no: r.pnr_no,
    routeTitle: r.routeTitle || "-",   // ✅ NEW FIELD

    reason: r.reason,
    days_of_leave: r.days_of_leave,
    refund_dates: r.refund_dates || [],
    totalRefund: r.totalRefund,

    status: r.status,
    createdAt: r.createdAt
      ? new Date(r.createdAt).toLocaleString()
      : "-"
  }));
}

